{
  "splash": {
    "title": "Desarrollado con el apoyo del Gobierno de Canadá"
  },
  "all-listings": {
    "disconnected": {
      "text": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en ACCÈS REFRAIN."
    },
    "needLogin": {
      "secondLine": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en ACCÈS REFRAIN."
    },
    "empty": {
      "offer": {
        "firstLine": "¡Comienza tu aventura aquí!",
        "primaryButtonText": "¡Publica una oferta!",
        "secondLine": "Participa en el catálogo ofreciendo objetos para prestar."
      },
      "invite": {
        "primaryButtonText": "Invita a los demás miembros",
        "secondLine": "Invita a los demás miembros o publica una oferta en tu barrio."
      }
    },
    "banner": {
      "xmas": {
        "text": "¡Se acercan las fiestas! Ayuda a los demás miembros a encontrar estos objetos tan solicitados."
      }
    },
    "inviteOthersPrompt": {
      "ctaButton": "Invita a los demás miembros"
    },
    "postOfferPrompt": {
      "firstAfter": {
        "button": "Invitar a los demás miembros",
        "title": "¡Invita a los demás miembros!"
      },
      "third": {
        "title": "Pregunta a los demás miembros"
      }
    }
  },
  "billboard": {
    "unauthenticatedTitle": "Crée un compte ou connecte-toi",
    "unauthenticatedTitle_2": "pour voir les ressources disponibles dans ACCÈS REFRAIN."
  },
  "common": {
    "appName": "ACCÈS REFRAIN",
    "appDownloadPrompt": {
      "guest": "¿Te gusta lo que ves? Lleva ACCÈS REFRAIN en tu teléfono y recibe nuevas disponibilidades cerca de ti",
      "qrCodeAccessibilityLabel": "Código QR para descargar la aplicación ACCÈS REFRAIN"
    }
  },
  "contact-information": {
    "prompt": "Agrega el código postal del festival para ver qué objetos están disponibles en los alrededores.",
    "title": "Tu festival"
  },
  "contact-us": {
    "firstParagraph": "El servicio a los miembros de ACCÈS REFRAIN está disponible por correo electrónico y mensajería. Te responderemos lo más rápido posible.",
    "faqLink": "https://lerefrain.com/fr/faq-acces-refrain",
    "chatPrompt": {
      "bugReport": "¡Hola! 😊\n\nGracias por explicarnos qué está fallando.",
      "suggestion": "¡Hola! 😊\n\nSiempre estamos abiertos a sugerencias. Gracias por ayudarnos a mejorar nuestro servicio.\n\n¡Gracias!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Se necesita un código de invitación para usar ACCÈS REFRAIN. Para obtener uno, visita <a>el espacio miembro Refrain</a>.",
    "activationCodeFieldHelpLink": "https://lerefrain.com/fr/connexion"
  },
  "guidelines": {
    "fifthParagraph": "No utilizar ACCÈS REFRAIN para vender objetos.",
    "startingKit": "Quiero recibir el <startingKitLink>Kit de inicio</startingKitLink> por correo para reclutar a los demás miembros (opcional)"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Se unió a ACCÈS REFRAIN",
        "title": "Explorador"
      }
    }
  },
  "introModal": {
    "title": "Estimado/a {{name}},",
    "first": "Bienvenido/a a la aplicación de intercambio y descubre el <strong>amplio catálogo de recursos materiales disponibles.</strong>",
    "second": "<strong>Compartir es una muestra de confianza</strong>: ¡cuanto más prestes, más ganas tendrán los demás de prestarte!",
    "third": "<strong>Sabe que menos del 0,1 % de todos los intercambios</strong> generan un daño. Y no es por mala fe. Es simplemente normal cuando los objetos se usan un poco más.",
    "notInsurable": {
      "community": "<strong>Es la oportunidad perfecta para conocer a los demás miembros</strong> y dar un paso hacia un mundo más sostenible."
    },
    "welcome": {
      "withWho": {
        "enterprise": "tus colegas y otros miembros",
        "municipal": "los demás miembros",
        "municipal_closed": "los demás miembros",
        "realestate": "los demás miembros"
      }
    }
  },
  "landing-page": {
    "popularInterests": "Categorías",
    "multipleOfferCard": {
      "title": "¡Seguro que tienes estos objetos!"
    },
    "immature": {
      "referral": {
        "button": "Invita a los demás miembros"
      }
    },
    "requests": {
      "emptyState": {
        "subtitle": "Te avisaremos si los demás miembros necesitan ayuda"
      }
    }
  },
  "my-information": {
    "firstNameFieldLabel": "Nombre del festival",
    "credentialInformationTitle": "Cuenta y seguridad",
    "personalInformationTitle": "Información del perfil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nombre del festival",
    "firstNameFieldPlaceholder": "ej. Festival del Buen Viento de Ste-Pépitte",
    "title": "Información del perfil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Tu suscripción a ACCÈS REFRAIN es cortesía del Refrain."
      },
      "title": {
        "enterprise": "Suscripción ACCÈS REFRAIN"
      }
    },
    "refrainPlan": {
      "firstParagraph": "",
      "title": "Suscripción ACCÈS REFRAIN"
    },
    "noEnd": "Esta suscripción es válida mientras seas miembro del Refrain.",
    "design": {
      "freeBorrowDescription": "Pide prestado tu primer objeto a los demás miembros gratis",
      "unlimitedLendingDescription": "Publica ofertas y presta tus objetos a los demás miembros tantas veces como quieras"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ej: Consola de sonido",
      "descriptionFieldPlaceholder": {
        "offer": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto...",
        "request": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenido/a al Club",
        "body": "¡Descubre ACCÈS REFRAIN!"
      }
    },
    "welcome": "¡Bienvenido/a a ACCÈS REFRAIN!",
    "welcomeMessage": "Gracias por confiar en nosotros.",
    "rate": {
      "borrower": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de ACCÈS REFRAIN."
      },
      "lender": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de ACCÈS REFRAIN."
      }
    },
    "loanReciprocity": {
      "message": "Publica los objetos que uses poco y compártelos con los demás miembros."
    }
  },
  "one-channel": {
    "levelModal": {
      "superSharer": {
        "message": "¡Aumentaste tu impacto realizando 5 intercambios! Ahora accedes al nivel máximo: <strong>Super Compartidor</strong>, un ejemplo a seguir para los otros miembros de ACCÈS REFRAIN.\n\n¡Bravo! Con cada intercambio, haces crecer tu impacto para un futuro más verde."
      }
    },
    "howItWorks": {
      "borrow": {
        "step2": "<bold>Propón</bold> fechas de préstamo, <bold>espera la confirmación</bold> del otro miembro y <bold>planifiquen la recogida</bold> juntos",
        "step3": "<bold>Recoge el objeto</bold> en casa del otro miembro o en un lugar público seguro. <bold>¡Sin intercambio de dinero, es gratis!</bold>"
      },
      "lend": {
        "step3": "<bold>Presta el objeto</bold> al otro miembro. <bold>¡Sin intercambio de dinero, es gratis!</bold>"
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "La necesidad fue cubierta en ACCÈS REFRAIN"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nombre del festival",
    "firstNameFieldPlaceholder": "ej. Festival del Buen Viento de Ste-Pépitte",
    "pictureFieldSubtitle": "Esta imagen se mostrará en tus anuncios y tu perfil.",
    "pictureFieldTitle": "Agregar una imagen del logo del festival",
    "title": "Información del perfil"
  },
  "privacy": {
    "link1": "https://lerefrain.com/fr/acces-refrain-conditions-dutilisation",
    "link2": "https://lerefrain.com/fr/acces-refrain-politique-de-confidentialite",
    "line3": "de ACCÈS REFRAIN."
  },
  "quick-new-thanks": {
    "bodyText": "¡Acabas de contribuir a enriquecer el catálogo de <strong>ACCÈS REFRAIN</strong>!\n\nPuedes modificar tus ofertas en cualquier momento en tu centro de intercambios."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contactar a ACCÈS REFRAIN"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "Al ofrecer tus objetos, animas incluso a los festivales más tímidos a pedir."
      }
    },
    "publishOffers": {
      "step2": {
        "text": "Al ofrecer tus objetos, animas incluso a <strong>los demás miembros más tímidos</strong> a pedir. Siempre puedes prestar tus objetos, <strong>incluso sin suscripción</strong>.\n\nPresiona el ícono para continuar. (2/5)"
      },
      "step2AltCorp": {
        "text": "Al ofrecer tus objetos, animas incluso a <strong>los demás miembros más tímidos</strong> a pedir.\n\nPresiona el ícono para continuar. (2/5)"
      }
    }
  },
  "festival": {
    "nextEdition": "Próxima edición",
    "changeLater": "Podrás cambiar la fecha más adelante en tu perfil",
    "startDate": "Fecha de inicio",
    "chooseDate": "Confirmar la fecha",
    "address": "Dirección",
    "profileTitle": "Fecha de la próxima edición",
    "missingDate": "Fecha por confirmar",
    "expired": "Caducada",
    "edit": "Modificar",
    "editTitle": "Modificar la fecha de la próxima edición",
    "cancel": "Cancelar",
    "save": "Guardar",
    "close": "Cerrar",
    "dateRequired": "Selecciona una fecha de inicio a partir de hoy.",
    "saveError": "No se pudo guardar la fecha. Inténtalo de nuevo.",
    "initialTitle": "¿Cuándo empieza la próxima edición?",
    "initialMessage": "Indica la fecha de inicio de la próxima edición de tu festival.",
    "reminderTitle": "¡En marcha hacia la próxima edición!",
    "reminderMessage": "Es hora de actualizar la fecha de inicio de la próxima edición de tu festival.",
    "updateDate": "Actualizar la fecha",
    "later": "Más tarde",
    "signupTitle": "Tu festival"
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Accès Refrain es la aplicación para <strong>compartir equipamiento</strong> entre festivales.",
      "footerText": "No te <strong>limites</strong> a lo que posee tu organización."
    },
    "accessMore": {
      "headerText": "En Accès Refrain, accedes a una <strong>abundancia de equipamiento</strong>.",
      "footerText": "Materiales, escenarios, etc.: aquí encuentras <strong>realmente de todo.</strong>"
    },
    "offerMore": {
      "headerText": "En Accès Refrain, <strong>compartir</strong> es <strong>ayudar</strong> a otros festivales mientras <strong>optimizas tus recursos</strong>.",
      "footerText": "Deja que otros festivales <strong>aprovechen</strong> tu equipamiento <strong>poco utilizado.</strong>"
    }
  },
  "help": {
    "guestCta": {
      "text": "Únete a otros miembros y descubre todo lo que puedes pedir prestado cerca de ti."
    },
    "borrower": {
      "steps": {
        "catalog": {
          "text": "Busca un objeto en el catálogo o publica una necesidad visible para otros miembros"
        },
        "meeting": {
          "text": "Propón y confirma las fechas de préstamo y recogida con el otro miembro"
        },
        "pickup": {
          "text": "Reúnete con el otro miembro en su domicilio o en un lugar público seguro. <strong>¡Sin intercambio de dinero, es gratis!</strong>"
        }
      }
    },
    "lender": {
      "steps": {
        "share": {
          "text": "Reúnete con el otro miembro en tu domicilio o en un lugar público seguro para entregarle el objeto. <strong>¡Sin intercambio de dinero, es gratis!</strong>"
        }
      }
    }
  },
  "free-sub": {
    "inviteButtonText": "Invitar a los demás miembros",
    "spreadTheLoveText": "¡Cuéntaselo a los demás miembros para que ellos también puedan aprovechar la oferta especial!"
  },
  "invite": {
    "referralProgram": {
      "shareText": "¡Hola!\n\nUso ACCÈS REFRAIN, una app genial para prestar y tomar prestados objetos cotidianos entre miembros: herramientas, juegos, material deportivo… ¡todo lo que quieras!\nEstoy seguro/a de que te va a encantar. Únete aquí:\n\n{{url}}"
    },
    "referralProgram202506": {
      "shareText": "¡Hola!\n\nUso ACCÈS REFRAIN, una app genial para prestar y tomar prestados objetos entre miembros: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy seguro/a de que te va a interesar. Únete aquí:\n\n{{url}}"
    },
    "shareText": "¡Hola!\n\nUso ACCÈS REFRAIN, una app genial para prestar y tomar prestados objetos entre miembros: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy seguro/a de que te va a interesar. Únete aquí:\n\n{{url}}",
    "title": "¡Invita a los demás miembros o personas cercanas!"
  },
  "loans": {
    "past": {
      "savings": {
        "header": {
          "lending": "Ahorrados por los demás miembros gracias a ti"
        }
      }
    }
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "secondLine": "¡Comparte tus objetos y mira cuánto dinero permites ahorrar a los miembros!"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "lending": {
          "secondLine": "¡Comparte tus objetos y mira cuánto dinero permites ahorrar a los miembros!"
        }
      }
    }
  },
  "my-neighbourhood": {
    "radiusDescription": "Tu radio te permite compartir tus anuncios dentro de un perímetro limitado de tu barrio. Los miembros que vivan fuera de esta zona no podrán ver tus anuncios."
  },
  "payment": {
    "modal": {
      "firstParagraph": "Gracias por tu confianza. Gracias a tu suscripción, ahora puedes tomar prestado y prestar objetos a los demás miembros sin límite."
    }
  },
  "posts": {
    "feed": {
      "endOfFeed": {
        "description": "Un objeto prestado, un nuevo encuentro…\nComparte tu historia con los demás miembros."
      }
    },
    "storyComposer": {
      "neighbour": "un miembro"
    }
  },
  "presentCommunity": {
    "newFlow": {
      "oneFreeBorrowDescription": "Pide prestado tu primer objeto a los demás miembros gratis",
      "unlimitedLendingDescription": "Publica ofertas y presta tus objetos a los demás miembros tantas veces como quieras"
    }
  },
  "profile-overview": {
    "inviteNeighboursButtonLabel": "Invitar miembros"
  },
  "recommendations": {
    "urgent-needs": {
      "title": "¡Ayuda a los demás miembros!"
    }
  },
  "streak": {
    "contributions": {
      "add_avatar": {
        "description": "Una foto de perfil tranquiliza a los demás miembros y te hace reconocible en el barrio."
      },
      "dismiss_request": {
        "title": "Intenta ayudar a los demás miembros"
      },
      "publish_offer": {
        "description": "Publica un objeto específico, o elige entre los objetos sugeridos ya compartidos por nuestros miembros."
      },
      "send_message": {
        "description": "¡Rompe el hielo! Escribe a un miembro para ofrecer tu ayuda o para saber más sobre un anuncio."
      }
    },
    "neighbourhoodFirstShare": "En tu barrio, <strong>{{percent}}% de los demás miembros</strong> hicieron su primer intercambio <strong>en menos de una semana</strong>",
    "objectiveDetails": "El objetivo del mes se determina en función del número de miembros que comparten a tu alrededor y la madurez de tu comunidad.",
    "seriesDetails": "Para mantener viva la llama del compartir, tú y los demás miembros deben alcanzar el objetivo de compartidos indicado para el mes.",
    "tips": {
      "helpNeighbours": {
        "title": "Intenta ayudar a los demás miembros"
      }
    }
  }
}
